// extracted by mini-css-extract-plugin
module.exports = {"image":"index_image__3GQd_"};